// ============================================================================
// SYSTEM CONFIGURATION ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/masters/system-config';

export const systemConfigEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
} as const;

export default systemConfigEndpoints;
